module.exports = __webpack_public_path__ + "static/media/text-image.02fd6d5a.avif";